import { useState, useEffect, useContext } from 'react';
import gql from 'graphql-tag';
import _ from 'lodash';
import MercuryContext from 'ConnectionManager/mercuryContext';
import { ACTIVITY } from '../../constants';

const getTitleActivityTitleGQL = gql`
query getTitleActivityTitle($cohortId: UUID!, $deploymentId: UUID!, $activityId: UUID!) {
  cohortById(cohortId: $cohortId) {
    id
    deployment(deploymentId: $deploymentId) {
      id
      activity(activityId:$activityId) {
        configurationFields(fieldNames:["title"]) {
          fieldName
          fieldValue
        }
      }
    }
  }
}
`;

export const getActivityTitles = async (apolloClient, { cohortId, deploymentId, activityIds }) => {
  const titles = await Promise.all(activityIds.map(async (activityId) => {
    const response = await apolloClient.query({
      query: getTitleActivityTitleGQL,
      variables: {
        cohortId,
        deploymentId,
        activityId,
      },
    });

    const title = _.chain(response)
      .get('data.cohortById.deployment.0.activity.configurationFields.0.fieldValue')
      .value();

    return {
      activityId,
      title,
    };
  }));

  return titles.reduce((acc, { activityId, title }) => ({ ...acc, [activityId]: title }), {});
};

export const useTitledAncestors = ({ cohortId, ancestry, deploymentId }) => {
  const { apolloClient } = useContext(MercuryContext);
  const [ancestors, setAncestors] = useState(
    ancestry
      .reverse()
      .filter(({ elementType }) => elementType === ACTIVITY)
  );
  useEffect(() => {
    if (!ancestors.find(({ title }) => !title)) { return; }

    getActivityTitles(apolloClient, {
      cohortId,
      deploymentId,
      activityIds: ancestors.map(({ elementId }) => elementId),
    })
      .then((ancestorsMap) => setAncestors(
        ancestors.map(({ elementId, ...rest }) => ({
          elementId,
          title: ancestorsMap[elementId],
          ...rest,
        }))
      ));
  }, [apolloClient, cohortId, deploymentId, ancestors]);

  return ancestors;
};
